<template>
	<div class="is-in-wechat" @click="closeWechatTip">
		<div class="ns-arrow-icon"></div>
		<p>{{ getConstants('OPEN_IN_BROWSER_TIP_1') }}</p>
		<p>{{ getConstants('OPEN_IN_BROWSER_TIP_2') }}</p>
	</div>
</template>
<script>
export default {
	methods: {
		closeWechatTip() {
			this.$emit('closeWechatTip')
		},
	},
}
</script>
<style lang="scss" scoped>
.is-in-wechat {
	position: fixed;
	width: 100%;
	height: 100%;
	color: #fff;
	font-size: 20px;
	text-indent: 20%;
	background: rgba(0, 0, 0, 0.8);
	left: 0;
	top: 0;
	z-index: 1024;

	.ns-arrow-icon {
		height: 100px;
		margin-top: 10px;
		margin-right: 20px;
		background: url('../images/svg/arrow.svg') no-repeat top right;
		background-size: 45px 80px;
	}
}
</style>
